import FieldModel from "./FieldModel.js";
import BaseModel from "./_mbase.js";

const doGroupPages = (fieldGroups, fields, allowConcatRemain = true) => {
    if (typeof fieldGroups !== 'string' || fieldGroups.length === 0) {
        return [];
    }
    const pages = fieldGroups.split(';');

    const remainFields = fields.reduce((output, current) => {
        output.set(current.code, current);
        return output;
    }, new Map());

    /**
     * @type {Array<FieldModel[]>}
     */
    const fieldsGroupped = pages.reduce((output, current) => {
        /**
         * @type {Array<FieldModel>}
         */
        const fieldsByPage = current.split(',').reduce((fields, code) => {
            const field = remainFields.get(code);
            if (field) {
                fields.push(field);
                remainFields.delete(code);
            }
            return fields;
        }, []);
        output.push(fieldsByPage);
        return output;
    }, [])

    if (allowConcatRemain && remainFields.size > 0) {
        fieldsGroupped.push(Array.from(remainFields.values()));
    }

    return fieldsGroupped;
}

class FormModel extends BaseModel {

    code = '';
    title = '';
    allowOrigin = '';
    /** @type FieldModel[]  */
    fields = [];
    formType = 0;
    redirectSuccessUrl = '';
    redirectSuccessUrlWhenNotUnique = '';
    recaptchaEnabled = false;
    recaptchaKey = '';
    recaptchaVersion = 'v3';
    isRegistrationSlotFully = false;
    redirectUrlWhenFully = '';
    fieldGroups = '';
    image = '';
    isContainLinkField = false
    linkingFields = {}
    previewSubmission = false
    hasEnded = false;

    fieldPaging = {
        /**@type { Array<FieldModel[]>} */
        fieldPages: [],
        pageIndex: 0
    }

    constructor() {
        super();
    }

    fromJSON(data) {
        super.fromJSON(data);
        this.id = data['id'];
        this.title = data['title'];
        this.code = data.code;
        this.formType = data['form_type'];
        this.fields = (data['fields'] || []).map(item => new FieldModel().fromJSON(item, this.uuid));
        // this.fields = [this.fields[0]]
        // this.fields = [this.fields.find(i => i.code === 'nature_of_disability')]
        this.allowOrigin = data['domain'];
        // this.allowOrigin = 'http://localhost:5501';
        this.redirectSuccessUrl = data['on_success_redirect'] || '';
        this.recaptchaKey = data['recaptcha_key'];
        this.recaptchaEnabled = Number(data['recaptcha_enabled']) == 1;
        this.isRegistraionSlotFully = Boolean(data['registration_is_fully_book']);
        this.redirectUrlWhenFully = data['registration_on_closure_redirect'] || '';
        this.fieldGroups = data['fieldgroup'];
        this.image = data['image']
        this.previewSubmission = Boolean(data['preview_submission'])
        this.redirectSuccessUrlWhenNotUnique = data['on_success_action']

        this.linkingField();
        this.groupPage();
        return this;
    }

    get isRedirectSuccessUrlValid() {
        return this.redirectSuccessUrl.length > 5;
    }

    get isExistCaptcha() {
        return this.recaptchaKey.length > 5 && this.recaptchaEnabled;
    }

    /**
     * 
     * @returns {Array<{code: string; value: string }>}
     */
    toUserResponses() {
        return this.fields.map(f => f.toUserResponse());
    }

    groupPage() {
        this.fieldPaging.fieldPages = doGroupPages(this.fieldGroups, this.fields);
    }


    onUserResponse(field, value) {
        console.log('userResponse', field, value)
    }

    linkingField() {
        if (this.fields.length === 0) return;
        let fields = new Map(this.fields.map((item) => [item.id, item]));
        fields = this.fields.reduce((out, field) => {
            const { code, fieldOptions } = field;
            if (fieldOptions.length > 0) {
                for (let i in fieldOptions) {
                    const { id, linkFieldId } = fieldOptions[i];
                    if (linkFieldId) {
                        out.delete(linkFieldId);
                    }
                }
            }
            return out;
        }, fields);
        this.isContainLinkField = fields.size < this.fields.length;
    }

    buildGroupPageWithLinking() {
        const currentPages = this.fieldPaging.fieldPages[this.fieldPaging.pageIndex];
        if (currentPages.length == 0) return;
        const fieldGroups = this.fieldGroups;
        const sSplitFields = new Set(fieldGroups.split(';'));
        const sNextFields = new Set();
        let needConcatNewPageGroup = false;
        for (let i in currentPages) {
            const field = currentPages[i];
            const { fieldOptions, userResponse, code } = field;
            if (fieldOptions.length === 0) continue;
            const sUserResponse = new Set(userResponse);
            for (let j in fieldOptions) {
                const fieldOption = fieldOptions[j];
                if (!fieldOption.linkFieldId) { continue }
                if (!sUserResponse.has(fieldOption.value)) {
                    this.clearUserResponseByFieldId(fieldOption.linkFieldId)
                    continue
                }
                const field = this.findFieldById(fieldOption.linkFieldId);
                sNextFields.add(field.code);
                needConcatNewPageGroup = true;
            }
        }
        if (sNextFields.size > 0) {
            const newFieldGroup = this.fieldGroups + ';' + Array.from(sNextFields).join(';');
            this.fieldPaging.fieldPages = doGroupPages(newFieldGroup, this.fields, false);
        }
    }

    getFields() {
        const { pageIndex, fieldPages } = this.fieldPaging
        if (fieldPages.length > 0) {
            return fieldPages[pageIndex]
        }
        return this.fields;
    }

    /**
     * 
     * @param {number} index 
     * @returns {boolean} True if the page index has been set
     */
    setPageIndex(index) {
        this.buildGroupPageWithLinking();
        if (index >= 0 && index <= this.fieldPaging.fieldPages.length - 1) {
            this.fieldPaging.pageIndex = index;
            return true
        }
        return false;
    }

    nextQuestion() {

    }

    backQuestion() {

    }

    hasPaging() {
        return this.totalPage() > 0;
    }

    totalPage() {
        return this.fieldPaging.fieldPages.length;
    }

    isLastPage() {
        return this.getPageIndex() === this.totalPage() - 1;
    }

    getPageIndex() {
        return this.fieldPaging.pageIndex;
    }

    toJSON() {

    }

    setFieldError(fieldCode, errorMsg) {
        const field = this.fields.find(f => f.code === fieldCode);
        if (field) {
            field.errorMsg = errorMsg;
        }
    }

    updateFieldModel(newFieldModel) {
        const index = this.fields.findIndex(f => f.code === newFieldModel.code);
        if (index > -1) {
            this.fields[index] = newFieldModel;
        }
    }

    findFieldById(id) {
        return this.fields.find(o => o.id === id);
    }

    clearUserResponseByFieldId(id) {
        const field = this.findFieldById(id);
        if (field) {
            field.userResponse = null;
        }
    }
}

export default FormModel;